import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withAuth } from '../AuthContext';
import { withSearch } from '../SearchContext';

const ListRequestsRedirect = ({ history }) => {
    const getLatestRequestType = () => {
        axios
            .get('/api/bookings/requests/latest-type')
            .then((response) => {
                const type = response.data;
                history.push(`/dashboard/requests/${type}`);
            })
            .catch(function(error) {
                // Default redirect to Live Requests in case of error
                history.push('/dashboard/requests/live');
            });
    };

    useEffect(() => {
        getLatestRequestType();
    }, []);
}

export default withRouter(withAuth(withSearch(ListRequestsRedirect)));
